import axiosInstance from 'api/axiosInstance';

export const unpinCase = async (
	userID: number,
	caseID: number,
): Promise<void> => {
	const data = {
		userID,
		caseID,
	};
	const response = await axiosInstance.post(
		`/api2.0/pinnedcases/unpinCase`,
		data,
	);

	if (response.status !== 200) {
		throw new Error(`Error unpinning case`);
	}
};
